import { createRequestId } from "./api";

export const SAFE_IDENTIFIER_PATTERN = String.raw`[A-Za-z0-9._\-]+`;

export function createBatchId(now = new Date(), uuid: string = createRequestId()) {
  const timestamp = now.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
  const suffix = uuid.replace(/^web-/, "").replaceAll("-", "").slice(0, 8);
  return `${timestamp}-${suffix}`;
}
